import { render, staticRenderFns } from "./AddRemittance.vue?vue&type=template&id=76dd021c&scoped=true&"
import script from "./AddRemittance.vue?vue&type=script&lang=js&"
export * from "./AddRemittance.vue?vue&type=script&lang=js&"
import style0 from "./AddRemittance.vue?vue&type=style&index=0&id=76dd021c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dd021c",
  null
  
)

export default component.exports